import { SliderRatingAttributeProps } from 'Types/Attribute.types'
import { Flex, Slider } from 'antd/lib'
import React, { FC, useCallback, useMemo } from 'react'
import '../SliderAttribute/Slider.less'

const SliderRatingAttribute: FC<SliderRatingAttributeProps> = props => {
    const step = useMemo(
        () => (props.options.length > 1 ? 100 / (props.options.length - 1) : 100),
        [props.options]
    )

    // Use useMemo to memoize generated marks
    const marks = useMemo(() => {
        const generatedMarks: Record<number, { label: React.ReactElement; value: string }> = {}
        const step = props.options.length > 1 ? 100 / (props.options.length - 1) : 100

        props.options.forEach((option, index) => {
            generatedMarks[index * step] = {
                label: <div>{option.label}</div>,
                value: option.value,
            }
        })

        return generatedMarks
    }, [props.options])

    const handleChange = useCallback(
        (sliderValue: number) => {
            const selectedMark = Object.values(marks).find(
                mark => mark.value === marks[sliderValue]?.value
            )
            props.onChange(selectedMark?.value)
        },
        [marks, props]
    )

    const findIndexByValue = useMemo(
        () => (targetValue: string) =>
            props.options.findIndex(option => option.value === targetValue),
        [props.options]
    )

    const findOptionByValue = useMemo(
        () => (targetValue: string) => props.options.find(option => option.value === targetValue),
        [props.options]
    )

    return (
        <div
            className={`slider-attribute ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="slider-rating-wrapper"
        >
            {!props.readonly ? (
                <div>
                    <div className="slider-attribute-title slider-attribute-editable">
                        <span>{props.label}</span>
                        <span>{findOptionByValue(props.value!)?.label}</span>
                    </div>
                    <Slider
                        value={findIndexByValue(props.value!) * step}
                        marks={marks}
                        onChange={handleChange}
                        tooltip={{ open: false }}
                        step={null}
                        disabled={props.readonly}
                    />
                </div>
            ) : (
                <Flex vertical className="slider-attribute-title">
                    <span>{props.label}</span>
                    <span className="slider-attribute-non-editable">
                        {findOptionByValue(props.value!)?.label}
                    </span>
                </Flex>
            )}
        </div>
    )
}

export default SliderRatingAttribute
